// extracted by mini-css-extract-plugin
export default {"infoButton":"setupfee-tooltip__infoButton___cKuDV","tooltipRoot":"setupfee-tooltip__tooltipRoot___xWBGn","setupFeeTooltipPopper":"setupfee-tooltip__setupFeeTooltipPopper___jHAOJ"};